module.exports = __webpack_public_path__ + "img/PS36.052ce643.png";